<template>
  <v-col class="person">
    <v-row>
      <bread-crumbs />

      <v-col class="text-right">
        <!-- Menu: Choose Report -->
        <v-row>
          <v-col>
            <v-menu
              dense
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dense
                  v-bind="attrs"
                  small
                  v-on="on"
                >
                  <span class="pr-2 subtitle-2 font-weight-medium">Layouts</span>

                  <font-awesome-icon
                    :icon="['fas', 'chevron-down']"
                  />
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  v-for="layout in layouts"
                  :key="layout.value"
                  @click="onLayoutChange(layout.value)"
                >
                  <v-list-item-title class="subtitle-2">
                    {{ layout.text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>

          <!--          <v-col>-->
          <!--            <v-btn-->
          <!--              v-if="isUserInternalAdmin"-->
          <!--              color="primary"-->
          <!--              @click="$store.dispatch('internal/showFormPersonCreate', undefined, { root: true })"-->
          <!--            >-->
          <!--              Create Person-->
          <!--            </v-btn>-->
          <!--          </v-col>-->
        </v-row>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col>
        <v-divider />
      </v-col>
    </v-row>

    <v-row v-if="showPersons && showSummaries">
      <v-col>
        <summary-card-bar />
      </v-col>
    </v-row>

    <v-row v-if="showLayoutToValidateUsers">
      <v-col>
        <v-row>
          <v-col>
            <v-card
              class="elevation-0"
              max-width="300px"
            >
              <v-card-title>
                <span class="heading">{{ currentItems.length }}</span>
              </v-card-title>

              <v-card-subtitle>
                <span class="subtitle-2">Accounts</span>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card
              class="elevation-0"
              max-width="900px"
            >
              <v-card-title class="darkblue--text">
                <v-col>
                  <span>Database</span>
                </v-col>
              </v-card-title>

              <v-card-text>
                <v-data-table
                  dense
                  :headers="databaseHeaders"
                  :items="databaseItems"
                  :items-per-page="10"
                  class="elevation-0"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <v-col>
                          <v-row>
                            <v-col class="pl-0 pb-0">
                              <span class="font-weight-bold">{{ item.personName }}</span>
                            </v-col>
                          </v-row>

                          <v-row class="mt-2">
                            <v-col class="pl-0 pt-0">
                              <span class="font-weight-medium">{{ item.email }}</span>
                            </v-col>
                          </v-row>
                        </v-col>
                      </td>

                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.isInternal"
                            class="grassgreen--text"
                            :icon="['fas', 'check']"
                          />

                          <font-awesome-icon
                            v-else
                            class="vuetifygray--text"
                            :icon="['fas', 'times']"
                          />
                        </v-col>
                      </td>

                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.isActive"
                            class="grassgreen--text"
                            :icon="['fas', 'check']"
                          />

                          <font-awesome-icon
                            v-else
                            class="toasted--text"
                            :icon="['fas', 'times']"
                          />
                        </v-col>
                      </td>

                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.isDeleted"
                            class="toasted--text"
                            :icon="['fas', 'trash']"
                          />

                          <font-awesome-icon
                            v-else
                            style="color: #c6d2db;"
                            :icon="['fas', 'trash']"
                          />
                        </v-col>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-card
              class="elevation-0"
              max-width="900px"
            >
              <v-card-title class="darkblue--text">
                <v-col>
                  <span>iAdOps</span>
                </v-col>
              </v-card-title>

              <v-card-text>
                <v-data-table
                  :headers="iadopsHeaders"
                  :items="iadopsItems"
                  :items-per-page="10"
                  class="elevation-0"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <v-col>
                          <v-row>
                            <v-col class="pl-0 pb-0">
                              <span class="font-weight-bold">{{ item.personName }}</span>
                            </v-col>
                          </v-row>

                          <v-row class="mt-2">
                            <v-col class="pl-0 pt-0">
                              <span class="font-weight-medium">{{ item.email }}</span>
                            </v-col>
                          </v-row>
                        </v-col>
                      </td>

                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.canAccessApps"
                            class="grassgreen--text"
                            :icon="['fas', 'check']"
                          />

                          <font-awesome-icon
                            v-else
                            class="toasted--text"
                            :icon="['fas', 'times']"
                          />
                        </v-col>
                      </td>

                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.isConfigValid"
                            class="grassgreen--text"
                            :icon="['fas', 'check']"
                          />

                          <font-awesome-icon
                            v-else
                            class="toasted--text"
                            :icon="['fas', 'times']"
                          />
                        </v-col>
                      </td>

                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.hasAccessErrors.length > 0"
                            :icon="['fas', 'exclamation-triangle']"
                            class="toasted--text"
                          />

                          <font-awesome-icon
                            v-else
                            :icon="['fas', 'exclamation-triangle']"
                            style="color: #c6d2db;"
                          />
                        </v-col>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card
              class="elevation-0"
              max-width="900px"
            >
              <v-card-title class="darkblue--text">
                <v-col>
                  <span>Users</span>
                </v-col>
              </v-card-title>

              <v-card-text>
                <v-data-table
                  :headers="userHeaders"
                  :items="userItems"
                  :items-per-page="10"
                  class="elevation-0"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <v-col>
                          <v-row>
                            <v-col class="pl-0 pb-0">
                              <span class="font-weight-bold">{{ item.personName }}</span>
                            </v-col>
                          </v-row>

                          <v-row class="mt-2">
                            <v-col class="pl-0 pt-0">
                              <span class="font-weight-medium">{{ item.email }}</span>
                            </v-col>
                          </v-row>
                        </v-col>
                      </td>

                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.isUserActive"
                            class="grassgreen--text"
                            :icon="['fas', 'check']"
                          />

                          <font-awesome-icon
                            v-else
                            class="toasted--text"
                            :icon="['fas', 'times']"
                          />
                        </v-col>
                      </td>

                      <td class="font-weight-medium">
                        {{ item['access.level'] }}
                      </td>

                      <td class="font-weight-medium">
                        {{ item['access.role'] }}
                      </td>

                      <td class="font-weight-medium">
                        {{ item['access.expires'] }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-card
              class="elevation-0"
              max-width="900px"
            >
              <v-card-title class="darkblue--text">
                <v-col>
                  <span>Reports</span>
                </v-col>
              </v-card-title>

              <v-card-text>
                <v-data-table
                  :headers="reportHeaders"
                  :items="reportItems"
                  :items-per-page="10"
                  class="elevation-0"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <v-col>
                          <v-row>
                            <v-col class="pl-0 pb-0">
                              <span class="font-weight-bold">{{ item.personName }}</span>
                            </v-col>
                          </v-row>

                          <v-row class="mt-2">
                            <v-col class="pl-0 pt-0">
                              <span class="font-weight-medium">{{ item.email }}</span>
                            </v-col>
                          </v-row>
                        </v-col>
                      </td>

                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.hasPacing"
                            class="grassgreen--text"
                            :icon="['fas', 'check']"
                          />

                          <font-awesome-icon
                            v-else
                            class="toasted--text"
                            :icon="['fas', 'times']"
                          />
                        </v-col>
                      </td>

                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.hasDiscrepancy"
                            class="grassgreen--text"
                            :icon="['fas', 'check']"
                          />

                          <font-awesome-icon
                            v-else
                            class="toasted--text"
                            :icon="['fas', 'times']"
                          />
                        </v-col>
                      </td>

                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.hasHealthNetwork"
                            class="grassgreen--text"
                            :icon="['fas', 'check']"
                          />

                          <font-awesome-icon
                            v-else
                            class="toasted--text"
                            :icon="['fas', 'times']"
                          />
                        </v-col>
                      </td>

                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.hasHealthAdx"
                            class="grassgreen--text"
                            :icon="['fas', 'check']"
                          />

                          <font-awesome-icon
                            v-else
                            class="toasted--text"
                            :icon="['fas', 'times']"
                          />
                        </v-col>
                      </td>
                      <td>
                        <v-col class="pl-0 text-center">
                          <font-awesome-icon
                            v-if="item.hasYieldPartner"
                            class="grassgreen--text"
                            :icon="['fas', 'check']"
                          />

                          <font-awesome-icon
                            v-else
                            class="toasted--text"
                            :icon="['fas', 'times']"
                          />
                        </v-col>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card
              class="elevation-0"
              max-width="900px"
            >
              <v-card-title class="darkblue--text">
                <v-col class="col-auto">
                  <span>JSON View</span>
                </v-col>

                <v-col class="text-right">
                  <v-btn
                    color="primary"
                    elevation="0"
                    small
                    @click="copyToClipboard(JSON.stringify(currentItems, null, 2))"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'copy']"
                      class="pr-2"
                    />
                    <span>Copy</span>
                  </v-btn>
                </v-col>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col>
                    <v-textarea
                      class="copy-field"
                      :value="JSON.stringify(currentItems, null, 2)"
                      readonly
                      rows="10"
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <person-table v-else-if="showPersons" />

    <person-profile v-else-if="showPerson" />

    <internal-error v-else />

    <person-modal v-if="isUserInternalAdmin" />
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import mixin from '../components/mixin'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapToolGetters, mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'Person',
  components: {
    BreadCrumbs: () => import('@/layout/components/BreadCrumbs'),
    PersonModal: () => import('../components/PersonModal'),
    PersonProfile: () => import('../components/Person.vue'),
    PersonTable: () => import('../components/Persons.vue'),
    SummaryCardBar: () => import('@/tools/components/summary/SummaryCardBar'),
  },
  mixins: [mixin],
  data: () => ({
    currentLayout: 'overview',
    layouts: [
      { text: 'Overview', value: 'overview' },
      { text: 'Validation Widgets', value: 'validation-widgets' },
    ],
    databaseHeaders: [
      { text: 'Name', value: 'personName', align: 'start', sortable: true },
      // { text: 'Email', value: 'email', sortable: false, visible: false },
      { text: 'Internal', value: 'isInternal', align: 'center', sortable: true },
      { text: 'Active', value: 'isActive', align: 'center', sortable: true },
      { text: 'Deleted', value: 'isDeleted', align: 'center', sortable: true },
    ],
    iadopsHeaders: [
      { text: 'Name', value: 'personName', align: 'start', sortable: true },
      // { text: 'Email', value: 'email' },
      { text: 'Access', value: 'canAccessApps', align: 'center', sortable: true },
      { text: 'Config', value: 'isConfigValid', align: 'center', sortable: true },
      { text: 'Errors', value: 'hasAccessErrors', align: 'center', sortable: true },
    ],
    reportHeaders: [
      { text: 'Name', value: 'personName', align: 'start', sortable: true },
      // { text: 'Email', value: 'email' },
      { text: 'Pacing', value: 'hasPacing', align: 'center', sortable: true },
      { text: 'Discrepancy', value: 'hasDiscrepancy', align: 'center', sortable: true },
      { text: 'Network Health', value: 'hasHealthNetwork', align: 'center', sortable: true },
      { text: 'AdX Health', value: 'hasHealthAdx', align: 'center', sortable: true },
      { text: 'AdX and OB', value: 'hasYieldPartner', align: 'center', sortable: true },
    ],
    userHeaders: [
      { text: 'Name', value: 'personName', align: 'start', sortable: true },
      // { text: 'Email', value: 'email' },
      { text: 'Active', value: 'isUserActive', align: 'center', sortable: true },
      { text: 'Level', value: 'access.level', align: 'start', sortable: true },
      { text: 'Role', value: 'access.role', align: 'start', sortable: true },
      { text: 'Expires', value: 'access.expires', align: 'start', sortable: true },
    ],
  }),
  computed: {
    ...mapAuthGetters(['isUserInternalAdmin']),
    ...mapToolGetters([
      'currentItems',
      'currentGroups',
      'isReportIdValid',
      'persons',
      'showSummaries',
    ]),
    ...mapToolsState({
      reportId: (state) => state.reportId,
    }),
    showPersons() {
      return (!this.reportId || !this.isReportIdValid) && this.currentLayout === 'overview'
    },
    showPerson() {
      return this.reportId && this.isReportIdValid
    },
    showLayoutToValidateUsers() {
      return this.currentLayout === 'validation-widgets'
    },
    databaseItems() {
      return this.currentItems.map((item) => ({
        personName: item.personName,
        email: item.email,
        isActive: item.isActive,
        isInternal: item.isInternal,
        isDeleted: item.isDeleted,
        isAdmin: item.isAdmin,
      }))
    },
    iadopsItems() {
      return this.currentItems.map((item) => ({
        personName: item.personName,
        email: item.email,
        canAccessApps: item.canAccessApps,
        isConfigValid: item.isConfigValid,
        hasAccessErrors: item.hasAccessErrors,
      }))
    },
    reportItems() {
      return this.currentItems.map((item) => ({
        personName: item.personName,
        email: item.email,
        hasPacing: item.network.reduce((acc, row) => acc || row.publisher.hasPacing, false),
        hasDiscrepancy: item.network.reduce((acc, row) => acc || row.publisher.hasDiscrepancy, false),
        hasHealthAdx: item.network.reduce((acc, row) => acc || (row.hasProgrammatic && row.publisher.hasHealthAdx), false),
        hasHealthNetwork: item.network.reduce((acc, row) => acc || (row.hasProgrammatic && row.publisher.hasHealthNetwork), false),
        hasYieldPartner: item.network.reduce((acc, row) => acc || (row.hasProgrammatic && row.publisher.hasYieldPartner), false),
      }))
    },
    userItems() {
      return this.currentItems.map((item) => ({
        personName: item.personName,
        email: item.email,
        isUserActive: item.isUserActive ? 'Yes' : 'No',
        'access.level': item.access.level,
        'access.role': item.access.role,
        'access.expires': item.access.expires,
      }))
    },
  },
  created() {
    // If the route's query.action = 'create' then we need to show the person modal.
    const { action, personEmail, personId } = this.$route.query

    if (action === 'create') {
      return this.$store.dispatch('internal/showFormPersonCreate', undefined, { root: true })
    }

    const havePersonId = typeof personId === 'string' && personId.length > 0
    const findByPersonId = (p) => p.personId === personId
    const findByPersonEmail = (p) => p.email === personEmail
    const findByQuery = havePersonId ? findByPersonId : findByPersonEmail

    const person = havePersonId && this.persons.find(findByQuery)

    if (action === 'update') {
      if (!person) {
        const message = 'Person not found. Please try again.'

        // Inform the user.
        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message, status: 'error' }, { root: true })
      } else {
        this.$store.dispatch('internal/showFormPersonUpdate', person)
      }
    }

    return person
  },
  methods: {
    onLayoutChange(value) {
      this.currentLayout = value
    },

    onCopySuccess() {
      this.copied = true
      this.showCopyMessage = true

      return true
    },

    onCopyError() {
      this.copied = false
      this.showCopyMessage = true

      return false
    },

    copyToClipboardFallback() {
      const el = this.$refs.inputTenantId

      if (!el.length) return this.onCopyError()

      el[0].select()

      document.execCommand('copy')

      return this.onCopySuccess()
    },

    async copyToClipboard(text) {
      if (!navigator.clipboard) {
        return this.copyToClipboardFallback(text)
      }

      return navigator.clipboard.writeText(text).catch(() => this.copyToClipboardFallback(text))
    },
  },
}
</script>

<style scoped>

.copy-field {
  max-height: 350px;
  overflow: scroll;
}

</style>
